function nunjucks_global_numberformat(i18n)
{
    this.name = 'numberFormat';
    this.value = function(number, decimals, dec_point, thousands_sep)
    {
        if (i18n.lang === 'hu') {
            return number_format(number, decimals||0, dec_point||',', thousands_sep||' ');
        } else {
            return number_format(number, decimals||0, dec_point||'.', thousands_sep||',');
        }
    };
}